import React, { useState } from 'react'
import { Spin } from 'antd'
import IntlMessages from '../util/IntlMessages'
import { useHistory } from 'react-router-dom'
import { useDispatch, useStore } from 'react-redux'

const NotAllowedComponent = props => {
  const { getAccessLoading, textType } = props // 1 for rights 2 for features
  const history = useHistory()
  const dispatch = useDispatch()

  return (
    <div className='Content-wrapper ProductDetails-pg'>
      <Spin
        tip={<IntlMessages id='dakarpos.allow.checkscreenaccess' />}
        spinning={getAccessLoading}
        size='large'
      >
        <h1 style={{ marginTop: '8%', textAlign: 'center' }}>
          {textType == 1 ? (
            <IntlMessages id='dakarpos.allow.read.screen' />
          ) : (
            <IntlMessages id='feature.pkg.not.allowed' />
          )}
        </h1>
      </Spin>
    </div>
  )
}

export default NotAllowedComponent
